import { render, staticRenderFns } from "./AdditionalResourcesModal.vue?vue&type=template&id=696040a2&scoped=true&"
import script from "./AdditionalResourcesModal.vue?vue&type=script&lang=js&"
export * from "./AdditionalResourcesModal.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalResourcesModal.vue?vue&type=style&index=0&id=696040a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../b_front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696040a2",
  null
  
)

export default component.exports